export default {
  title: 'Wheel Configuration',
  actions: {
    create: 'create a wheel',
    confirmDelete: 'Are you sure you want to delete this wheel?',
    delete: 'Delete',
    next: 'Next',
    cancel: 'Cancel',
    save: 'Save'
  },
  empty: {
    title: 'No wheels',
    message: 'To create a wheel, nothing could be easier, just click on the following link:'
  },
  create: {
    title: 'Create a wheel',
    fields: {
      name: 'Name',
      date: {
        name: 'Date',
        start: 'Start',
        end: 'End'
      },
      where: 'Where'
    }
  },
  list: {
    name: 'name',
    code: 'code',
    status: 'status',
    where: 'where',
    date: 'date',
    stats: 'stats'
  },
  gifts: {
    title: 'Gifts',
    description: 'Decide if you want to give gift to your users, and customize it.',
    enable: {
      title: 'Do you want to enable gifts ?',
      toggle: 'The wheel works fine without gifts ;) Users will get points on each run.'
    },
    list: 'Gifts repartition',
    new: 'Add a new gift',
    out: 'out of',
    create: {
      edit: 'Edit gift',
      title: 'Create a gift',
      name: 'Gift name',
      description: 'Computer',
      heading: 'What is the heading ?',
      placeholder: 'Heading of the gift',
      quantity: 'What is the quantity ?',
      stock: 'Stock :',
      value: '10',
      item: 'item(s)'
    }
  },
  notification: {
    error: 'An error occurred while saving the wheel',
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/wheel.js